import { SxProps, Theme, Typography } from "@mui/material";

type GroupsNameProps = {
    headerName?: string;
    sx?: SxProps<Theme>;
};

export const FieldName = ({ headerName = "", sx }: GroupsNameProps) => {
    return (
        <Typography sx={{ color: "primary.main", ...sx }} variant="subtitle1">
            {headerName}
        </Typography>
    );
};
